import { render } from "./KpiEdit.vue?vue&type=template&id=01534bf8&scoped=true"
import script from "./KpiEdit.vue?vue&type=script&lang=js"
export * from "./KpiEdit.vue?vue&type=script&lang=js"

import "./kpi.scss?vue&type=style&index=0&id=01534bf8&lang=scss&scoped=true"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01534bf8"]])

export default __exports__